import { SwalMessage } from "../js/Tools";

var Tours = function () {

    const ElementHandle = function () {
        const form = document.querySelector('[data-tour-search]');
        if (!form) {
            return;
        }

        // Tarih seçici
        const dateInput = form.querySelector("[data-search-date]");
        if (dateInput) {
            $(dateInput).flatpickr({
                minDate: "today",
                dateFormat: "d.m.Y",
                locale: "tr",
            });
        }

        // Select2
        var type = form.querySelector("[data-search-type]")

        $(type).select2({
            placeholder: "Tur tipini seçin",
            allowClear: true,
            width: "100%",
        });

        var where = form.querySelector("[data-search-where]")

        $(where).select2({
            placeholder: "Nereye gitmek istediğinizi seçin",
            allowClear: true,
            width: "100%",
        });

        // Tarih seçimi değiştiğinde price code'u güncelle
        const tourDateSelect = document.querySelector('[data-select-tour-date]');
        if (tourDateSelect) {
            // İlk yüklemede seçili tarihin price code'unu ayarla
            const initialDate = tourDateSelect.value;
            if (initialDate) {
                const initialPriceRow = document.querySelector(`#tour-price-list [data-tour-date-value="${initialDate}"]`);
                if (initialPriceRow) {
                    const mainRow = initialPriceRow.closest('tr');
                    const initialPriceCode = mainRow.getAttribute('data-tour-price-code');
                    if (initialPriceCode) {
                        tourDateSelect.setAttribute('data-tour-price-code', initialPriceCode);
                    } else {
                        console.error('Initial price code not found for date:', initialDate);
                    }
                } else {
                    console.error('Initial price row not found for date:', initialDate);
                }
            }

            // Change event listener
            $(tourDateSelect).on('change', function() {
                const selectedDate = this.value;
                if (selectedDate) {
                    const priceRow = document.querySelector(`#tour-price-list [data-tour-date-value="${selectedDate}"]`);
                    if (priceRow) {
                        const mainRow = priceRow.closest('tr');
                        const priceCode = mainRow.getAttribute('data-tour-price-code');
                        if (priceCode) {
                            this.setAttribute('data-tour-price-code', priceCode);
                        } else {
                            console.error('Price code not found for selected date:', selectedDate);
                        }
                    } else {
                        console.error('Price row not found for selected date:', selectedDate);
                    }
                }
            });
        }

        // çocuk doğum tarihi
        $("[data-search-child-date]").flatpickr({
            dateFormat: "d.m.Y",
            locale: "tr",
            maxDate: "today",
            onChange: function(selectedDates, dateStr, instance) {
                const tourDateSelect = document.querySelector('[data-select-tour-date]');
                if (tourDateSelect) {
                    const selectedDate = tourDateSelect.value;
                    if (selectedDate) {
                        const priceRow = document.querySelector(`#tour-price-list [data-tour-date-value="${selectedDate}"]`);
                        if (priceRow) {
                            const priceCode = priceRow.closest('tr').getAttribute('data-tour-price-code');
                            if (priceCode) {
                                handlePriceControl(priceCode, selectedDate);
                            }
                        }
                    }
                }
            }
        });

        // bebek doğum tarihi
        $("[data-search-baby-date]").flatpickr({
            dateFormat: "d.m.Y",
            locale: "tr",
            maxDate: "today",
            onChange: function(selectedDates, dateStr, instance) {
                const tourDateSelect = document.querySelector('[data-select-tour-date]');
                if (tourDateSelect) {
                    const selectedDate = tourDateSelect.value;
                    if (selectedDate) {
                        const priceRow = document.querySelector(`#tour-price-list [data-tour-date-value="${selectedDate}"]`);
                        if (priceRow) {
                            const priceCode = priceRow.closest('tr').getAttribute('data-tour-price-code');
                            if (priceCode) {
                                handlePriceControl(priceCode, selectedDate);
                            }
                        }
                    }
                }
            }
        });

        // Fiyat tablosundaki seç butonlarına tıklama olayı
        const priceTableButtons = document.querySelectorAll('#tour-price-list [data-tour-button-select]');
        if (priceTableButtons) {
            priceTableButtons.forEach(button => {
                button.addEventListener('click', function() {
                    console.log('button clicked');
                    // En yakın tr elementini bul
                    const row = this.closest('tr');
                    // Önce ana tbody'yi bul, sonra bir üst tr'ye çık ve oradan tarihi bul
                    const tbody = row.closest('tbody');
                    const mainRow = tbody.parentElement.closest('tr');
                    const dateValueElement = mainRow.querySelector('th[scope="row"] [data-tour-date-value]');
                    
                    if (dateValueElement) {
                        const dateValue = dateValueElement.getAttribute('data-tour-date-value');
                        const tourSelectedPriceCode = dateValueElement.getAttribute('data-tour-price-code');
                        
                        // Tarih seçimini güncelle
                        const tourDateSelect = document.querySelector('[data-select-tour-date]');
                        if (tourDateSelect) {
                            $(tourDateSelect).val(dateValue).trigger('change');
                            tourDateSelect.setAttribute('data-tour-price-code', tourSelectedPriceCode);
                            // Tarih seçim alanına scroll yap
                            tourDateSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    } else {
                        console.log('dateValueElement not found');
                    }
                });
            });
        }
    }

    const NullCheck = function (value) {
        if (value == null || value == undefined || value == '') {
            return true;
        }

        return false;
    }


    const SearchHandle = function () {
        const form = document.querySelector('[data-tour-search]');

        if (!form) {
            return;
        }

        const provinceSelectElement = form.querySelector('[data-search-where]');
        const dateInputElement = form.querySelector('[data-search-date]');

        const typeSelectElement = form.querySelector('[data-search-type]');
        const submitButtonElement = form.querySelector('[data-search-submit]');


        $(submitButtonElement).on('click', function (event) {
            event.preventDefault();

            let provinceValue = provinceSelectElement.value;
            // console.log('province', provinceValue);
            if (NullCheck(provinceValue)) {
                SwalMessage(
                    {
                        type: "error",
                        text: "Nereye gitmek istediğinizi seçmelisiniz.",
                        confirmButton: translate.ok_button
                    },
                    function () {
                        // location.reload();
                    }
                );
                return;
            }

            let dateValue = dateInputElement.value;
            // console.log('date', dateValue);
            // if (NullCheck(dateValue)) {
            //     SwalMessage(
            //         {
            //             type: "error",
            //             text: "Tarih girmelisiniz.",
            //             confirmButton: translate.ok_button
            //         },
            //         function () {
            //             // location.reload();
            //         }
            //     );
            //     return;
            // }

            let typeValue = typeSelectElement.value;
            // console.log('type', typeValue);
            // if (NullCheck(typeValue)) {
            //     SwalMessage(
            //         {
            //             type: "error",
            //             text: "Tur tipini seçmelisiniz.",
            //             confirmButton: translate.ok_button
            //         },
            //         function () {
            //             // location.reload();
            //         }
            //     );
            //     return;
            // }

            var data = {
                province: provinceValue,
                date: dateValue,
                type: typeValue
            };


            // Veriyi URL formatına dönüştürme
            var queryString = Object.keys(data).map(
                key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            ).join('&');

            location.href = `${baseUrl}/tour?${queryString}`;

        })



    }

    const ChildrenDates = function () {


        const elementList = document.querySelector('#childrens-dates');

        const config = document.querySelector("[data-search-guests-config]");
		const maxAdultCount = config ? JSON.parse(config.getAttribute("data-search-guests-config")).adult : hotelSettings.maxAdult;
		const maxChildCount = config ? JSON.parse(config.getAttribute("data-search-guests-config")).child : hotelSettings.maxChild;
		const maxBabyCount = config ? JSON.parse(config.getAttribute("data-search-guests-config")).baby : hotelSettings.maxBaby;

        const addChildrenDate = function (value = null) {

            let clone = elementList.querySelector('[data-search-child-date-template]').cloneNode(true);
            clone.classList.remove('d-none');
            clone.removeAttribute('data-search-child-date-template');

            if (value != null) {
                clone.querySelector('input').value = value;
            }

            elementList.appendChild(clone);

            ElementHandle();
        }

        const removeChildrenDate = function () {
            let lastElement = elementList.lastElementChild;
            if (lastElement != null && lastElement != undefined) {

                if (!lastElement.classList.contains('d-none')) {
                    lastElement.remove();
                    return;
                }
            }
        }

        $(document).on('click', '#children-add-btn', function (e) {
            e.preventDefault();
            let childCount = document.querySelector('#guests-count-children').innerText;


            let elementListCount = elementList.childElementCount - 1;

            if (elementListCount >= maxChildCount) {
                // SwalMessage(
                //     {
                //         type: "error",
                //         text: "Çocuk sayısı en fazla " + hotelSettings.maxChild + " olabilir.",
                //         confirmButton: translate.ok_button
                //     },
                //     function () {
                //         // location.reload();
                //     }
                // );
                return;
            } else {
                addChildrenDate();
            }

        });


        $(document).on('click', '#children-subs-btn', function (e) {
            e.preventDefault();
            let childCount = document.querySelector('#guests-count-children').innerText;

            removeChildrenDate();
        });


        const childrenCountEl = document.querySelector("#guests-count-children");
        if (childrenCountEl?.innerText > 0) {
            let childDatesEl = document.querySelector('#childrens-dates').getAttribute('data-child-dates');
            let childDates = childDatesEl.split(',');
            for (let i = 0; i < childrenCountEl.innerText; i++) {
                console.log(childDates[i]);
                addChildrenDate(childDates[i]);
            }
        }
    }

    const BabiesDates = function () {


        const elementList = document.querySelector('#babies-dates');

        const config = document.querySelector("[data-search-guests-config]");
		const maxBabyCount = config ? JSON.parse(config.getAttribute("data-search-guests-config")).baby : hotelSettings.maxBaby;

        const addChildrenDate = function (value = null) {

            let clone = elementList.querySelector('[data-search-baby-date-template]').cloneNode(true);
            clone.classList.remove('d-none');
            clone.removeAttribute('data-search-baby-date-template');

            if (value != null) {
                clone.querySelector('input').value = value;
            }

            elementList.appendChild(clone);

            ElementHandle();
        }

        const removeChildrenDate = function () {
            let lastElement = elementList.lastElementChild;
            if (lastElement != null && lastElement != undefined) {

                if (!lastElement.classList.contains('d-none')) {
                    lastElement.remove();
                    return;
                }
            }
        }

        $(document).on('click', '#babies-add-btn', function (e) {
            e.preventDefault();
            let childCount = document.querySelector('#guests-count-babies').innerText;


            let elementListCount = elementList.childElementCount - 1;

            if (elementListCount >= maxBabyCount) {
                // SwalMessage(
                //     {
                //         type: "error",
                //         text: "Çocuk sayısı en fazla " + hotelSettings.maxChild + " olabilir.",
                //         confirmButton: translate.ok_button
                //     },
                //     function () {
                //         // location.reload();
                //     }
                // );
                return;
            } else {
                addChildrenDate();
            }

        });


        $(document).on('click', '#babies-subs-btn', function (e) {
            e.preventDefault();
            let childCount = document.querySelector('#guests-count-babies').innerText;

            removeChildrenDate();
        });


        const childrenCountEl = document.querySelector("#guests-count-babies");
        if (childrenCountEl?.innerText > 0) {
            let childDatesEl = document.querySelector('#babies-dates').getAttribute('data-child-dates');
            let childDates = childDatesEl.split(',');
            for (let i = 0; i < childrenCountEl.innerText; i++) {
                addChildrenDate(childDates[i]);
            }
        }
    }

    const PriceControlHandle = function () {
        const form = document.querySelector('[data-tour]');

        if (!form) {
            return;
        }

        // İlk yüklemede seçili tarihin price code'unu ayarla
        const tourDateSelect = document.querySelector('[data-select-tour-date]');
        if (tourDateSelect) {
            const initialDate = tourDateSelect.value;
            if (initialDate) {
                const initialPriceRow = document.querySelector(`#tour-price-list [data-tour-date-value="${initialDate}"]`);
                if (initialPriceRow) {
                    const initialPriceCode = initialPriceRow.closest('tr').getAttribute('data-tour-price-code');
                    tourDateSelect.setAttribute('data-tour-price-code', initialPriceCode);
                    handlePriceControl(initialPriceCode, initialDate);
                }
            }

            // Change event listener
            $(tourDateSelect).on('change', function() {
                const selectedDate = this.value;
                const priceRow = document.querySelector(`#tour-price-list [data-tour-date-value="${selectedDate}"]`);
                if (priceRow) {
                    const priceCode = priceRow.closest('tr').getAttribute('data-tour-price-code');
                    this.setAttribute('data-tour-price-code', priceCode);
                    handlePriceControl(priceCode, selectedDate);
                }
            });
        }

        // Seç butonuna tıklandığında
        const priceTableButtons = document.querySelectorAll('#tour-price-list [data-tour-button-select], #adults-add-btn, #children-add-btn, #babies-add-btn, #adults-subs-btn, #children-subs-btn, #babies-subs-btn');
        if (priceTableButtons) {
            priceTableButtons.forEach(button => {
                button.addEventListener('click', function() {
                    const tourDateSelect = document.querySelector('[data-select-tour-date]');
                    if (tourDateSelect) {
                        const selectedDate = tourDateSelect.value;
                        if (selectedDate) {
                            const priceRow = document.querySelector(`#tour-price-list [data-tour-date-value="${selectedDate}"]`);
                            if (priceRow) {
                                const priceCode = priceRow.closest('tr').getAttribute('data-tour-price-code');
                                if (priceCode) {
                                    handlePriceControl(priceCode, selectedDate);
                                } else {
                                    console.error('Price code not found for selected date:', selectedDate);
                                }
                            } else {
                                console.error('Price row not found for selected date:', selectedDate);
                            }
                        } else {
                            console.error('No date selected');
                        }
                    }
                });
            });
        }
    }

    const SendPriceControlRequest = function (data) {
        // API endpoint
        const url = `${apiUrl}/TourPriceControl`;

        // API isteği gönder
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(result => {
            if (result.code == 200) {
                // Kişi başı fiyat
                const perPersonElement = document.querySelector('[data-tour-price-per-person]');
                if (perPersonElement && result.row.person_price) {
                    perPersonElement.textContent = `${result.row.person_price}`;
                }

                // Toplam fiyat
                const totalElement = document.querySelector('[data-tour-price-total]');
                if (totalElement && result.row.total_price) {
                    totalElement.textContent = `${result.row.total_price}`;
                }

                // Kişi bilgisi
                const personInfoElement = document.querySelector('[data-tour-price-person-info]');
                if (personInfoElement) {
                    personInfoElement.textContent = `${result.row.person_info}`;
                }
                
            } else {
                // Hata varsa
                SwalMessage({
                    type: "error",
                    text: (result.message || result.text) || "Bir hata oluştu, lütfen tekrar deneyin.",
                    confirmButton: translate.ok_button
                });
            }
        })
        .catch(error => {
            console.error('Fiyat kontrol hatası:', error);
        });
    }

    // handlePriceControl fonksiyonunu global scope'a taşıyorum
    const handlePriceControl = function(priceCode, date) {
        // Misafir sayıları
        const adultCount = document.querySelector('#guests-count-adults').textContent;
        const childrenCount = document.querySelector('#guests-count-children').textContent;
        const babiesCount = document.querySelector('#guests-count-babies').textContent;

        // Çocuk doğum tarihleri
        const childDates = [];
        const childDateInputs = document.querySelectorAll('#childrens-dates [data-search-child-date]');
        childDateInputs.forEach(input => {
            if (input.value) {
                childDates.push(input.value);
            }
        });

        // Bebek doğum tarihleri
        const babyDates = [];
        const babyDateInputs = document.querySelectorAll('#babies-dates [data-search-baby-date]');
        babyDateInputs.forEach(input => {
            if (input.value) {
                babyDates.push(input.value);
            }
        });

        // API isteği için veri hazırla
        const requestData = {
            tour_price_code: priceCode,
            tour_date: date,
            adult_count: parseInt(adultCount),
            children_count: parseInt(childrenCount),
            babies_count: parseInt(babiesCount),
            children_birth_dates: childDates,
            babies_birth_dates: babyDates
        };

        // API isteği gönder
        SendPriceControlRequest(requestData);
    }

    return {
        init: function () {
            if (document.querySelector('[data-tour-search]')) {
                ElementHandle();
                SearchHandle();
                ChildrenDates();
                BabiesDates();
                PriceControlHandle();
            }
        }
    }
}();

var Reservation = function () {
    // Form verilerini localStorage'a kaydetme fonksiyonu
    const saveFormData = function(formElement) {
        if (!formElement) return;
        
        const reservationNumber = formElement.getAttribute('data-reservation-number');
        if (!reservationNumber) return;

        const formData = {};
        const inputs = formElement.querySelectorAll('input, select, textarea');
        
        inputs.forEach(input => {
            if (input.name && input.value) {
                formData[input.name] = input.value;
            }
        });

        localStorage.setItem(`tour_reservation_${reservationNumber}`, JSON.stringify(formData));
    }

    // Form verilerini localStorage'dan yükleme fonksiyonu
    const loadFormData = function(formElement) {
        if (!formElement) return;
        
        const reservationNumber = formElement.getAttribute('data-reservation-number');
        if (!reservationNumber) return;

        const savedData = localStorage.getItem(`tour_reservation_${reservationNumber}`);
        if (!savedData) return;

        const formData = JSON.parse(savedData);
        
        Object.keys(formData).forEach(name => {
            const input = formElement.querySelector(`[name="${name}"]`);
            if (input) {
                input.value = formData[name];
            }
        });
    }

    // Form verilerini localStorage'dan silme fonksiyonu
    const clearFormData = function(formElement) {
        if (!formElement) return;
        
        const reservationNumber = formElement.getAttribute('data-reservation-number');
        if (!reservationNumber) return;

        localStorage.removeItem(`tour_reservation_${reservationNumber}`);
    }

    // Form işleme ve kaydetme özelliği
    const handleFormStorage = function(form) {
        if (!form) return;

        console.log('Rezervasyon formu bulundu');
        // Sayfa yüklendiğinde kayıtlı verileri yükle
        loadFormData(form);

        // Input değişikliklerinde verileri kaydet
        form.addEventListener('input', function() {
            console.log('Form verisi kaydediliyor...');
            saveFormData(this);
        });

        // textarea değişikliklerinde verileri kaydet
        form.addEventListener('textarea', function() {
            console.log('Form verisi kaydediliyor...');
            saveFormData(this);
        });

        // Form gönderildiğinde localStorage'ı temizle
        form.addEventListener('submit', function() {
            console.log('Form verisi temizleniyor...');
            clearFormData(this);
        });
    }

    // Rezervasyon butonuna tıklandığında
    const reservationButton = document.querySelector('[data-tour-reservation-btn]');
    if (reservationButton) {
        reservationButton.addEventListener('click', async function() {
            const tourDateSelect = document.querySelector('[data-select-tour-date]');
            if (tourDateSelect) {
                const selectedDate = tourDateSelect.value;
                const priceCode = tourDateSelect.getAttribute('data-tour-price-code');
                
                if (!selectedDate || !priceCode) {
                    SwalMessage({
                        type: "error",
                        text: "Lütfen bir tarih seçin.",
                        confirmButton: translate.ok_button
                    });
                    return;
                }

                // Misafir sayıları
                const adultCount = document.querySelector('#guests-count-adults').textContent;
                const childrenCount = document.querySelector('#guests-count-children').textContent;
                const babiesCount = document.querySelector('#guests-count-babies').textContent;

                // Çocuk doğum tarihleri
                const childDates = [];
                const childDateInputs = document.querySelectorAll('#childrens-dates [data-search-child-date]');
                childDateInputs.forEach(input => {
                    if (input.value) {
                        childDates.push(input.value);
                    }
                });

                // Bebek doğum tarihleri
                const babyDates = [];
                const babyDateInputs = document.querySelectorAll('#babies-dates [data-search-baby-date]');
                babyDateInputs.forEach(input => {
                    if (input.value) {
                        babyDates.push(input.value);
                    }
                });

                // Rezervasyon verilerini hazırla
                const reservationData = {
                    tour_price_code: priceCode,
                    tour_date: selectedDate,
                    adult_count: parseInt(adultCount),
                    children_count: parseInt(childrenCount),
                    babies_count: parseInt(babiesCount),
                    children_birth_dates: childDates,
                    babies_birth_dates: babyDates
                };

                try {
                    // TourReservation API'sine istek gönder
                    const reservationResponse = await fetch(`${apiUrl}/TourReservation`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        },
                        body: JSON.stringify(reservationData)
                    });

                    const reservationResult = await reservationResponse.json();

                    if (reservationResult.code === 200) {
                        // Fiyat kontrolü başarılı ise adım 1'e yönlendir
                        SwalMessage(
                            {
                                type: "success",
                                text: reservationResult.text,
                                confirmButton: translate.ok_button
                            },
                            function () {

                            }
                        );

                        if (reservationResult.redirectUrl != null && reservationResult.redirectUrl != undefined) {
                            window.location = reservationResult.redirectUrl;
                        }

                    } else {
                        // Hata mesajını göster
                        let errorMessage = "Bir hata oluştu, lütfen tekrar deneyin.";
                        
                        if (reservationResult?.text) {
                            errorMessage = reservationResult.text;
                        }

                        SwalMessage({
                            type: "error",
                            text: errorMessage,
                            confirmButton: translate.ok_button
                        });
                    }
                } catch (error) {
                    console.error('Fiyat kontrolü hatası:', error);
                    SwalMessage({
                        type: "error",
                        text: "Bir hata oluştu, lütfen tekrar deneyin.",
                        confirmButton: translate.ok_button
                    });
                }
            }
        });
    }

    const Step1 = function () {
        const form = document.querySelector('[data-form-step="1"]');

        if (!form) {
            return;
        }

        // Form kaydetme özelliğini aktif et
        handleFormStorage(form);

        const reservationNumber = form.getAttribute('data-reservation-number');
    
        const submitButtonElement = form.querySelector('[data-form-submit]');
    
        $(submitButtonElement).on('click', function (event) {
            event.preventDefault();
    
            let formData = new FormData(form);
            formData.append('reservationNumber', reservationNumber);
    
            // formData validation
            let error = false;
            form.querySelectorAll('input').forEach(function (element) {
                if (element.hasAttribute('required')) {
                    if (element.value == null || element.value == undefined || element.value == '') {
                        element.classList.add('border-danger');
                        element.focus();
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                        SwalMessage(
                            {
                                type: "error",
                                text: "Lütfen zorunlu alanları doldurunuz.",
                                confirmButton: translate.ok_button
                            },
                            function () {
    
                            }
                        );
                        error = true;
                        return;
                    } else {
                        element.classList.remove('border-danger');
                    }
                }
            });
    
    
            if (error) {
                return;
            }
    
            fetch(form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
    
                    if (data.code == 200) {

                        clearFormData(form);

                        // ToastMessage("1", '', xhr.responseJSON.text ?? xhr.responseJSON.message)
                        if (data.redirectUrl != null && data.redirectUrl != undefined) {
                            window.location = data.redirectUrl;
                        }
                    } else {
                        SwalMessage(
                            {
                                type: "error",
                                text: data.text,
                                confirmButton: translate.ok_button
                            },
                            function () {
                                if (data.redirectUrl != null && data.redirectUrl != undefined) {
                                    window.location = data.redirectUrl;
                                }
                            }
                        );
                    }
    
                })
                .catch((error) => {
                    // console.error('Error:', error);
                });
    
        })
    
    }

    const Step2 = function () {
        const form = document.querySelector('[data-form-step="2"]');

        if (!form) {
            return;
        }

        // Form kaydetme özelliğini aktif et
        handleFormStorage(form);

        const reservationNumber = form.getAttribute('data-reservation-number');
    
        const submitButtonElement = form.querySelector('[data-form-submit]');
    
        $(submitButtonElement).on('click', function (event) {
            event.preventDefault();
    
            let formData = new FormData(form);
            formData.append('reservationNumber', reservationNumber);
    
            // formData validation
            let error = false;
            form.querySelectorAll('input').forEach(function (element) {
                if (element.hasAttribute('required')) {
                    if (element.value == null || element.value == undefined || element.value == '') {
                        element.classList.add('border-danger');
                        element.focus();
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                        SwalMessage(
                            {
                                type: "error",
                                text: "Lütfen zorunlu alanları doldurunuz.",
                                confirmButton: translate.ok_button
                            },
                            function () {
    
                            }
                        );
                        error = true;
                        return;
                    } else {
                        element.classList.remove('border-danger');
                    }
                }
            });
    
    
            if (error) {
                return;
            }
    
            fetch(form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
    
                    if (data.code == 200) {

                        clearFormData(form);

                        // ToastMessage("1", '', xhr.responseJSON.text ?? xhr.responseJSON.message)
                        if (data.redirectUrl != null && data.redirectUrl != undefined) {
                            window.location = data.redirectUrl;
                        }
                    } else {
                        SwalMessage(
                            {
                                type: "error",
                                text: data.text,
                                confirmButton: translate.ok_button
                            },
                            function () {
                                if (data.redirectUrl != null && data.redirectUrl != undefined) {
                                    window.location = data.redirectUrl;
                                }
                            }
                        );
                    }
    
                })
                .catch((error) => {
                    // console.error('Error:', error);
                }
            );

        })

    }


    return {
        init: function () {

            let form = document.querySelector('#tour-reservation-form');

            if (form == null || form == undefined) {
                return;
            }

            if (form?.getAttribute('data-form-step') == 1) {
                Step1();
            }

            if (form?.getAttribute('data-form-step') == 2) {
                Step2();
            }
        }
    }
}();

$(function () {
    Tours.init();
    Reservation.init();
});

